import { Injectable, makeStateKey, StateKey } from '@angular/core';

// TransferState keys must be identical between the server response and the browser that hydrates it.
// A static counter breaks that guarantee: one server process serves many requests from a single
// module instance, so its count never resets (and interleaves under concurrency), while every
// browser starts from zero. Scoping the counter to the injector gives each server request and each
// browser app its own zero-based sequence, so the hydration guard's keys line up again.
@Injectable({ providedIn: 'root' })
export class LetStateKeyFactory {
  private nextId = 0;

  public next(): StateKey<boolean> {
    return makeStateKey<boolean>(`rmaLet${this.nextId++}`);
  }
}
